import {isLoggedIn} from '../../utils/auth'
import {injectReducer} from '../../store/reducers'
import {productWiseSalesAnalyticsReducer, productWiseSalesAnalyticsForCSVReducer} from './modules/ProductWiseSalesAnalytics'

export default (store) => ({
  path: 'product-wise-sales-analytics',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const ProductWiseSalesAnalytics = require('./containers/ProductWiseSalesAnalytics').default
      let homeReducers = require('../Home/modules/home');
      const {loadBillFieldsReducer} = require('../SalesForecasts/modules/salesForecasts');
      const {loadStoreOptionsReducer, loadStoreTagOptionsReducer} = require('../SalesAnalytics/modules/salesAnalytics');
      const {loadSalesChannelsReducer} = require('../DetailedAnalytics/modules/DetailedAnalytics');
      /*  Add the reducer to the store on key 'counter'  */
      const filterValuesReducer = homeReducers.filterValuesReducer;
      injectReducer(store, {key: 'productWiseSalesDetails', reducer: productWiseSalesAnalyticsReducer})
      injectReducer(store, {key: 'productWiseSalesDetailsForCSV', reducer: productWiseSalesAnalyticsForCSVReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})
      injectReducer(store, {key: 'filter', reducer: filterValuesReducer})
      injectReducer(store, {key: 'billFields', reducer: loadBillFieldsReducer});
      injectReducer(store, {key: 'channels', reducer: loadSalesChannelsReducer});

      cb(null, ProductWiseSalesAnalytics)

      /* Webpack named bundle   */
    }, 'productWiseSalesAnalytics')
  }
})



// WEBPACK FOOTER //
// ./src/routes/ProductWiseSalesAnalytics/index.js